export default __webpack_public_path__ + "images/Notes.v-0dd5a86a48eb4cdf16f084da3dbeba35.png";